export function parseStartParam(param: string | null | undefined): { path: string } | null {
  if (!param) return null;
  const m = /^chat_(brief|cfm)_(.+)$/.exec(param);
  if (!m) return null;
  const surface = m[1];
  const ref = m[2];
  return { path: `/chat?surface=${surface}&seedRef=${surface}:${ref}` };
}
